import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";
import { reduxForm, Field, SubmissionError } from "redux-form";
import PropTypes from "prop-types";
import { DTrees } from "reducers/DTrees";
import { dtreeNameExists, dtreeNameMaxLength, dtreeNameAllowedChars } from 'widgets/forms/validators/DTrees';
import { Modal, Button, ReduxControls, ProgressIndicator } from "rhombus-react";
import { DUPLICATE_DTREE } from "forms/list";

import "./DuplicateDTreeModal.css";

function DuplicateDTreeModal(props) {
	const dispatch = useDispatch()
		, {
			name,
			dtreeId,
			libraryId,
			commonModalProps,
			navigationActions,
			valid,
			handleSubmit,
		} = props
		, { popModal } = navigationActions
		, modalTitle = `Duplicate Decision Tree - ${name}`
		, [isSubmitting, setIsSubmitting] = useState(false)
		, disableSubmit = !valid || isSubmitting
		, onSubmit = handleSubmit(({ newDTreeName }) => {
			setIsSubmitting(true);
			return dtreeNameExists(dispatch, libraryId, newDTreeName, "newDTreeName").then((response) => {
				if (!response) { // if no response, then this dtree name is available
					dispatch(DTrees.duplicateDTree(newDTreeName, dtreeId)).then((response) => {
						setIsSubmitting(false);
						if (response?.success) {
							popModal();
						}
					});
				} else { // else (if response), then this dtree name is already taken
					setIsSubmitting(false);
					throw new SubmissionError(response);
				}
			});
		})
		;

	if (!name || !dtreeId) {
		return null;
	}

	const renderContent = () => (
		<div className="c-modal-body form-group duplicate-dtree-modal-form">
			<ProgressIndicator isLoading={isSubmitting} />
			<form className="form" id={DUPLICATE_DTREE} onSubmit={onSubmit}>
				<div className="duplicate-dtree-form">
					<Field
						name="newDTreeName"
						label="Name for Duplicated Decision Tree"
						component={ReduxControls.Input}
						validate={[dtreeNameMaxLength, dtreeNameAllowedChars]}
					/>
				</div>
			</form>
		</div>
	);

	const renderFooter = () => ([
		<Button key="back" type="reset" disabled={isSubmitting} theme="default" onClick={popModal}>Back</Button>,
		<Button key="save" type="submit" disabled={disableSubmit} form={DUPLICATE_DTREE}>Duplicate</Button>
	]);

	return (
		<Modal
			{...commonModalProps}
			className="duplicate-dtree-modal"
			title={modalTitle}
			onClose={popModal}
			renderContent={renderContent}
			renderFooter={renderFooter}
		/>
	);
}

DuplicateDTreeModal.displayName = "DuplicateDTreeModal";

DuplicateDTreeModal.propTypes = {
	name: PropTypes.string.isRequired,
	dtreeId: PropTypes.number.isRequired,
	libraryId: PropTypes.number.isRequired,
	navigationActions: PropTypes.object,
	commonModalProps: PropTypes.object,
};

DuplicateDTreeModal.defaultProps = {
	name: "",
	dtreeId: null,
	libraryId: null,
	navigationActions: {},
	commonModalProps: {},
};

function mapStateToProps(state, ownProps) {
	let { name } = ownProps;
	return {
		initialValues: {
			newDTreeName:	`${name}_copy`,
		},
	};
}

const ConnectedDuplicateDTreeModal = reduxForm({
	form: DUPLICATE_DTREE,
	enableReinitialize: true,
})(DuplicateDTreeModal);

export default connect(mapStateToProps, null)(ConnectedDuplicateDTreeModal);
